export function parseFormData(formData: FormData): Record<string, string> {
  const data: Record<string, string> = {};
  for (const [key, value] of formData.entries()) {
    data[key] = value.toString();
  }
  return data;
}

export function stringifyFormData(data: Record<string, string>): FormData {
  const formData = new FormData();
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, value);
  }
  return formData;
}

export function turnFormDataToJSON(formData: FormData): string {
  const data: Record<string, string> = {};
  for (const [key, value] of formData.entries()) {
    data[key] = value.toString();
  }
  return JSON.stringify(data);
}

export function validateFormData(data: Record<string, string>): boolean {
  for (const [key, value] of Object.entries(data)) {
    if (!value) {
      return false;
    }
  }
  return true;
}

export function sanitizeFormData(
  data: Record<string, string>
): Record<string, string> {
  const sanitizedData: Record<string, string> = {};
  for (const [key, value] of Object.entries(data)) {
    sanitizedData[key] = value.trim();
  }
  return sanitizedData;
}

export function sanitizeAndValidateFormData(
  data: Record<string, string>
): Record<string, string> {
  const sanitizedData = sanitizeFormData(data);
  return validateFormData(sanitizedData) ? sanitizedData : {};
}

export function createInitialData() {
  return {
    ok: false,
    status: 200,
    message: "",
    data: null,
  };
}

// Helper function to convert time string to minutes
export const timeToMinutes = (timeStr: string) => {
  const [hours, minutes] = timeStr.split(":").map(Number);
  return hours * 60 + minutes;
};

// Helper function to convert minutes to time string
export const minutesToTime = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, "0")}:${mins
    .toString()
    .padStart(2, "0")}`;
};
